var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"white-box",staticStyle:{"margin-left":"20px","margin-right":"20px"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }